module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.levelData), function(item, index) {
    return [_c('div', {
      staticClass: "level-item"
    }, [_c('div', {
      staticClass: "section-header with-border clearfix"
    }, [_c('h3', {
      staticClass: "f_l"
    }, [(item.lv_type == 'vip') ? _c('span', [_vm._v("VIP")]) : _c('span', [_vm._v("SVIP")])]), _vm._v(" "), (index != 0 && _vm.levelData.length - 1 == index) ? _c('span', {
      staticClass: "el-icon-close f_r",
      on: {
        "click": function($event) {
          return _vm.remove(index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-box clearfix"
    }, [_c('div', {
      staticClass: "preview-box f_l",
      on: {
        "click": function($event) {
          return _vm.getIndex(index)
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "upload-box",
      on: {
        "click": function($event) {
          return _vm.handleImgChange(item, index)
        }
      }
    }, [(item.background_pic_url) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.wximageurl + item.background_pic_url
      }
    }) : _c('i', {
      staticClass: "el-icon-plus avatar-uploader-icon"
    })])]), _vm._v(" "), _c('imgPicker', {
      attrs: {
        "dialog-visible": _vm.imgDialog,
        "sc-status": _vm.isGetImage
      },
      on: {
        "chooseImg": _vm.pickImg,
        "closeImgDialog": _vm.closeImgDialog
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "content-center"
    }, [_vm._v("卡封面（建议尺寸：xx * xx）")])], 1), _vm._v(" "), _c('div', {
      staticClass: "item-content f_l"
    }, [_c('div', [_c('span', {
      staticClass: "txt"
    }, [_vm._v("等级名称")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "360px"
      },
      attrs: {
        "maxlength": 12,
        "placeholder": "最多填写12个汉字",
        "name": index + ''
      },
      on: {
        "blur": _vm.nameblur
      },
      model: {
        value: (item.grade_name),
        callback: function($$v) {
          _vm.$set(item, "grade_name", $$v)
        },
        expression: "item.grade_name"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "frm-tips"
    }, [_vm._v(_vm._s(item.grade_name.length) + "/12")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "type": "hidden",
        "name": index + ''
      },
      model: {
        value: (item.lv_type),
        callback: function($$v) {
          _vm.$set(item, "lv_type", $$v)
        },
        expression: "item.lv_type"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "txt f_l"
    }, [_vm._v("购买金额")]), _vm._v(" "), [_c('div', {
      staticClass: "f_l"
    }, [_vm._l((item.price_list), function(list, i) {
      return _c('div', {
        staticStyle: {
          "margin-bottom": "5px"
        }
      }, [_vm._v("\n                    " + _vm._s(list.desc) + " "), _c('el-input', {
        staticStyle: {
          "width": "80px"
        },
        attrs: {
          "name": index + ''
        },
        model: {
          value: (list.price),
          callback: function($$v) {
            _vm.$set(list, "price", $$v)
          },
          expression: "list.price"
        }
      }), _vm._v(" 元\n                  ")], 1)
    })], 2)]], 2), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "txt f_l"
    }, [_vm._v("购买引导文本")]), _vm._v(" "), _c('div', {
      staticClass: "f_l"
    }, [_c('el-input', {
      staticStyle: {
        "width": "380px"
      },
      attrs: {
        "type": "textarea",
        "rows": 3,
        "placeholder": "请输入内容",
        "name": index + ''
      },
      model: {
        value: (item.guide_title),
        callback: function($$v) {
          _vm.$set(item, "guide_title", $$v)
        },
        expression: "item.guide_title"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "frm-tips"
    }, [_vm._v("30")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "txt f_l"
    }, [_vm._v("详细说明")]), _vm._v(" "), _c('div', {
      staticClass: "f_l"
    }, [_c('vue-html5-editor', {
      ref: "editor",
      refInFor: true,
      attrs: {
        "content": item.description,
        "height": 360
      },
      on: {
        "change": _vm.updateContent
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tpl_item img",
      on: {
        "click": _vm.addImgPreview
      }
    }, [_c('i', {
      staticClass: "iconfont icon-image"
    }), _vm._v("图片\n              ")])], 1), _vm._v(" "), _c('imgPicker', {
      attrs: {
        "dialog-visible": _vm.thumbDialog,
        "sc-status": _vm.isGetThumb,
        "isMost": true
      },
      on: {
        "chooseImg": _vm.pickThumb,
        "closeImgDialog": _vm.closeThumbDialog
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "txt f_l"
    }, [_vm._v("默认展示")]), _vm._v(" "), _c('div', {
      staticClass: "f_l"
    }, [_c('el-radio', {
      staticStyle: {
        "width": "380px"
      },
      attrs: {
        "label": item.lv_type
      },
      model: {
        value: (_vm.IsDefault),
        callback: function($$v) {
          _vm.IsDefault = $$v
        },
        expression: "IsDefault"
      }
    }, [_vm._v(_vm._s(item.grade_name))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "txt f_l"
    }, [_vm._v("是否禁用")]), _vm._v(" "), _c('div', {
      staticClass: "f_l"
    }, [_c('el-switch', {
      model: {
        value: (item.is_disabled),
        callback: function($$v) {
          _vm.$set(item, "is_disabled", $$v)
        },
        expression: "item.is_disabled"
      }
    })], 1)])])])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "section-footer content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveGrade
    }
  }, [_vm._v("保存")])], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-128d106c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-128d106c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/membercard/viplevel.vue
// module id = 2480
// module chunks = 0